import {http} from "Services/Http/HttpClient";
import FilterBuilder from "Services/Filters/FilterBuilder";
import {searchAdminInscriptionSpecialNeeds} from "./SpecialNeedQuery";

export const getChildren = async (filters: any = {}, sort: string = '', size=12): Promise<unknown> => {
    filters = {
        ...filters,
        sort: sort,
        size: size
    }
    const queryParams = FilterBuilder.hashMapToQueryString(filters)
    return await http.get('children' + (queryParams ? '?' + queryParams : ''))
}

export const exportAdminChildren = async(
    filters: any = {}
) : Promise<any> => {
    const newFilters: any = {...filters, csv: "1"}
    return getChildren(newFilters)
}

export const getChildrenDetail = async (id: string): Promise<unknown> => {
    return await http.get('children/' + id)
}
